import { postData } from '@/services/api.service';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { fetchCroppedImage } from '@/utils/constants';
import ImageCropper from '@/components/imageCropper/imageCropper';
import {
  bannerSlider1,
  bannerSlider2,
  bannerSlider3,
  bannerSlider4,
  bannerSlider5,
} from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { RootState } from '@/core/redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';

const BannerEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [images, setImages] = useState<Array<string>>([]);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);
  const handleHeaderChange = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_1: {
            ...prevJsonData.theme_2.home.section_1,
            [name]: value,
          },
        },
      },
    }));
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };
  const handleImageChange = (image: string) => {
    let updated_card_section = [
      ...editData.theme_2.home.section_1.card_section,
    ];
    updated_card_section[activeTab] = image;
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_1: {
            ...prevJsonData.theme_2.home.section_1,
            card_section: updated_card_section,
          },
        },
      },
    }));
  };
  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template1';
      const currentTemplate = templateImages[templateKey];
      const bannerImages = currentTemplate?.banner || [];
      
      if (Array.isArray(bannerImages) && bannerImages.length > 0) {
        // Load all banner images without aspect ratio filtering
        const imageUrls = bannerImages.map((img: any) => img.url);
        setImages(imageUrls);
      } else {
        setImages([]);
      }
    } else {
      setImages([]);
    }
  }, [templateImages, template]);

  // Auto-generate prompt based on banner context
  const generateAutoPrompt = (): string => {
    // Get context from the current banner data (theme_2)
    const title1 = editData?.theme_2?.home?.section_1?.title_1 || '';
    const title2 = editData?.theme_2?.home?.section_1?.title_2 || '';
    const title3 = editData?.theme_2?.home?.section_1?.title_3 || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional banner image for website hero section';
    
    if (title1 || title2 || title3) {
      const contextParts: string[] = [];
      if (title3) {
        contextParts.push(`"${title3}"`);
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add banner-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, wide format suitable for hero banner, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the image on the current card
    handleImageChange(imageUrl);
    
    // Add to images array for slider
    setImages(prevImages => [...prevImages, imageUrl]);
  };

  // HTML
  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section One Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <h4 className="edit-section-hdr">Title Section </h4>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Title One
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleHeaderChange({
                            target: {
                              name: 'title_1',
                              value: content,
                            },
                          });
                        }}
                        contentType="hero_section"
                        placeholder="Describe what you want in your title. Example: 'Write a catchy banner title'"
                        context="This is for a banner section title upto 6 words"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="title_1"
                      value={editData?.theme_2?.home?.section_1?.title_1}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                    <div className="mt-2">
                      <label className="form-label small">Title One Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_1_color"
                          value={
                            editData?.theme_2?.home?.section_1?.title_1_color || '000000'
                          }
                          onChange={handleHeaderChange}
                        />
                        <ColorPicker
                          name="title_1_color"
                          format="hex"
                          onChange={handleHeaderChange}
                          value={
                            editData?.theme_2?.home?.section_1?.title_1_color || '000000'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Title Two
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleHeaderChange({
                            target: {
                              name: 'title_2',
                              value: content,
                            },
                          });
                        }}
                        contentType="hero_section"
                        placeholder="Describe what you want in your title. Example: 'Write a catchy banner title'"
                        context="This is for a banner section title upto 6 words"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="title_2"
                      value={editData?.theme_2?.home?.section_1?.title_2}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                    <div className="mt-2">
                      <label className="form-label small">Title Two Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_2_color"
                          value={
                            editData?.theme_2?.home?.section_1?.title_2_color || '000000'
                          }
                          onChange={handleHeaderChange}
                        />
                        <ColorPicker
                          name="title_2_color"
                          format="hex"
                          onChange={handleHeaderChange}
                          value={
                            editData?.theme_2?.home?.section_1?.title_2_color || '000000'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Title Three
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleHeaderChange({
                            target: {
                              name: 'title_3',
                              value: content,
                            },
                          });
                        }}
                        contentType="hero_section"
                        placeholder="Describe what you want in your title. Example: 'Write a catchy banner title'"
                        context="This is for a banner section title upto 6 words                            "
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="title_3"
                      value={editData?.theme_2?.home?.section_1?.title_3}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                    <div className="mt-2">
                      <label className="form-label small">Title Three Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="title_3_color"
                          value={
                            editData?.theme_2?.home?.section_1?.title_3_color || '000000'
                          }
                          onChange={handleHeaderChange}
                        />
                        <ColorPicker
                          name="title_3_color"
                          format="hex"
                          onChange={handleHeaderChange}
                          value={
                            editData?.theme_2?.home?.section_1?.title_3_color || '000000'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="edit-section">
                <div className="row">
                  <div className="col">
                    <div className=" mb-3">
                      <label className="form-label">Button Text</label>
                      <input
                        type="text"
                        className="form-control"
                        name="btntext"
                        value={editData?.theme_2?.home?.section_1?.btntext}
                        onChange={handleHeaderChange}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className=" mb-3">
                      <label className="form-label">Background</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="btnbg_color"
                          value={
                            editData?.theme_2?.home?.section_1?.btnbg_color
                          }
                          onChange={handleHeaderChange}
                        />
                        <ColorPicker
                          name="btnbg_color"
                          format="hex"
                          onChange={handleHeaderChange}
                          value={
                            editData?.theme_2?.home?.section_1?.btnbg_color
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className=" mb-3">
                      <label className="form-label">Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="btncolor"
                          value={editData?.theme_2?.home?.section_1?.btncolor}
                          onChange={handleHeaderChange}
                        />
                        <ColorPicker
                          name="btncolor"
                          format="hex"
                          onChange={handleHeaderChange}
                          value={editData?.theme_2?.home?.section_1?.btncolor}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <label className="form-label">Placeholder</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="btnplaceholder"
                          value={
                            editData?.theme_2?.home?.section_1?.btnplaceholder
                          }
                          maxLength={250}
                          onChange={handleHeaderChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_2?.home?.section_1?.card_section.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Image {index + 1}
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_2?.home?.section_1?.card_section.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active text-center">
                            <img src={card} alt={`Card Icon ${index + 1}`} />
                          </div>
                          <div className="img-options w-100">
                            {images.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {images.map((imageUrl, iconIndex) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() => {
                                        handleImageChange(imageUrl);
                                      }}
                                    >
                                      <img
                                        src={imageUrl}
                                        alt="Hero Image"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Images Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI images or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              <AIImageGenerator
                generateAutoPrompt={generateAutoPrompt}
                onSave={handleAIImageSave}
                imageType="banner"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="mb-3">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  name="image"
                  onChange={updateImageSectionOne}
                />
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default BannerEditModal;
